import { PAGE_INFO_FIELDS } from "@/graphql/pagination";
import gql from "graphql-tag";

import { ADDRESS_FIELDS, CONNECTED_USER_FRAGMENT } from "../shared";

export const CONNECTED_USERS_QUERY = gql`
  query ConnectedUsersQuery($page: Int, $orderBy: String, $search: String, $organisationId: ID!) {
    connectedUsersPagination(
      page: $page
      orderBy: $orderBy
      search: $search
      organisationId: $organisationId
    ) {
      items {
        ...ConnectedUserFragment
      }
      pageInfo {
        ...PageInfoFields
      }
    }
  }
  ${CONNECTED_USER_FRAGMENT}
  ${PAGE_INFO_FIELDS}
`;

export const ORGANISATION_PATIENT_SHIPPING_ADDRESS_QUERY = gql`
  query OrganisationPatientShippingAddressQuery($patientId: ID!, $organisationId: ID!) {
    organisationPatientShippingAddress(patientId: $patientId, organisationId: $organisationId) {
      ...AddressFields
    }
  }
  ${ADDRESS_FIELDS}
`;

export const ORGANISATION_USER_TESTS_FOR_REVIEW_QUERY = gql`
  query OrganisationUserTestsForReview(
    $organisation: ID!
    $page: Int
    $pageSize: Int
    $orderBy: String
    $search: String
  ) {
    organisationUserTestsForReviewPagination(
      organisation: $organisation
      page: $page
      pageSize: $pageSize
      orderBy: $orderBy
      search: $search
    ) {
      items {
        id
        user {
          id
          fullName
          email
        }
        testProduct {
          id
          name
          paymentIsoCode
          organisation
        }
        orderTestItem {
          id
          providerTestId
        }
      }
      pageInfo {
        ...PageInfoFields
      }
      totalCount
    }
  }
  ${PAGE_INFO_FIELDS}
`;
